import { TCountryCode } from 'countries-list';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

type StoreChallengeAuthState = {
  challengeAuth?: string;
  auth?: string;
  address?: string;
  setChallengeAuth: (challengeAuth: string) => void;
  setAuth: (auth: string) => void;
  setAddress: (address: string) => void;
};

export const useAuth = create<StoreChallengeAuthState>()(
  persist(
    (set) => ({
      challengeAuth: undefined,
      setChallengeAuth: (challengeAuth) => set({ challengeAuth }),
      auth: undefined,
      setAuth: (auth) => set({ auth }),
      address: undefined,
      setAddress: (address) => set({ address }),
    }),
    {
      name: 'puzzle-quests-auth-storage',
      storage: createJSONStorage(() => {
        // Check if we're in iOS WebView
        const isWebview = /PuzzleWallet/i.test(navigator.userAgent);
        // Use localStorage for iOS WebView, sessionStorage otherwise
        return isWebview ? localStorage : sessionStorage;
      }),
    }
  )
);

type StoreSettingsState = {
  countryCode?: TCountryCode | 'global';
  setCountryCode: (countryCode: TCountryCode | 'global') => void;
};

export const useSettings = create<StoreSettingsState>()(
  persist(
    (set) => ({
      countryCode: undefined,
      setCountryCode: (countryCode: TCountryCode | 'global') =>
        set({ countryCode }),
    }),
    {
      name: 'puzzle-quests-settings-storage',
      version: 1,
    }
  )
);
